import Env from '../base/env.js'
import 'babel-polyfill'
import axios from 'axios'
import Serializer from 'form-serialize'

export default class MailSender
{
    constructor(_view)
    {
        this.view = _view
        this.$form = this.view.querySelector('.jsSender--view');
        this.$callbacksFields = this.view.querySelectorAll('.cbs')
        this.$fields = document.querySelectorAll('.field')
        if(this.$form == null) return false;
        this.events()
        this.loadCsrf();
    }

    events()
    {
        this.$form.addEventListener('submit',(event)=> {
            if(!this.$form.classList.contains('for--success') && !this.$form.classList.contains('for--error') && !this.$form.classList.contains('for--loading'))
            {
                this.send()
            }
            event.preventDefault();
        })

    }

    loadCsrf()
    {
        axios.get(config.pathRoot+'form-tok').then((response)=> {
            let $input = document.createElement('input')
            $input.setAttribute('name','_token')
            $input.setAttribute('type','hidden')
            $input.value = response.data
            this.$form.appendChild($input)
        });
    }

    ok()
    {
        this.$form.classList.add('for--success');
    }

    resetCallbackFields()
    {
        for(let i = 0; i < this.$callbacksFields.length; i++){
            const $callbackField = this.$callbacksFields[i]
            $callbackField.classList.remove('has--error')
            $callbackField.innerHTML = ''
        }
    }

    resetFields()
    {
        for(let i = 0; i < this.$fields.length; i++){
            const $field = this.$fields[i]
            $field.classList.remove('has--error')
        }
    }

    send()
    {

        const $datas = Serializer(this.$form , { hash: true})

        this.$form.classList.remove('for--success')
        this.$form.classList.remove('for--error')
        this.$form.classList.remove('for--loading')
        this.$form.classList.add('for--loading')
        axios({
            method: "post",
            url: this.$form.getAttribute('action'),
            data: $datas,
            responseType : 'json'
        }).then((_response)=>{
            this.$form.classList.remove('for--loading')
            this.resetFields();
            this.resetCallbackFields()
            for(let $key of Object.keys(_response.data.messages)){
                const $text = _response.data.messages[$key]
                const $element = document.querySelector(`.cb-${$key}`)
                $element.innerHTML = $text
                for(let $item of $element.parentElement.querySelectorAll('.field')){
                    $item.classList.add('has--error')
                }
            }
            if(_response.data.success)
            {
                this.ok();
            }
        })
    }
}